// Source: https://github.com/sroucheray/contain-cover/blob/master/contain-cover.js
function fit(contains) {
    return function (containerWidth, containerHeight, width, height) {
        var doRatio = width / height;
        var cRatio = containerWidth / containerHeight;
        var targetWidth = 0;
        var targetHeight = 0;
        var test = contains ? doRatio > cRatio : doRatio < cRatio;
        if (test) {
            targetWidth = containerWidth;
            targetHeight = targetWidth / doRatio;
        }
        else {
            targetHeight = containerHeight;
            targetWidth = targetHeight * doRatio;
        }
        return {
            width: targetWidth,
            height: targetHeight,
            x: (containerWidth - targetWidth) / 2,
            y: (containerHeight - targetHeight) / 2
        };
    };
}
export var contain = fit(true);
export var cover = fit(false);
